import React from 'react';
import * as _ from 'lodash';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';

import EventMg from '../utilities/EventManager';
import { enableTouch } from '../utilities/tabletUtil';
import {
  isLoginUserPartner,
  isLoginUserPrimaryCompany,
  isPartnerRoleId,
} from '../utilities/roleUtility';
import {
  isApiFlagOff,
  isApiFlagOn,
  getTransitionEndEventName,
} from '../utilities/commonUtil';
import { replaceTagInErrorMessage } from '../utilities/stringUtil';
import {
  APPROVAL_STATUS_FIELDTREE,
  JOINING_FLAG,
  FIELD_TREE_CCUS_SYNCED_STATUS,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';

import Tippy from '../components/ReactTippy';
import { getKeyApprovalFlagById } from '../services/fieldTrees/FieldTreesService';
import { QuestionIcon } from './icons/QuestionIcon';

const PRIMARY_PARTNER_NODE_LEVEL = 1;
const TRANSITION_END_EVENT_NAME = getTransitionEndEventName();
/**
 * 施工体系図の会社のBOX
 *
 * @export
 * @class FieldTreeCompany
 * @extends {React.Component}
 */
export default class FieldTreeCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickable: false,
      roleId: LocalStorageService.getRoleId(),
      companyBranchId: Number(SessionStorageService.getCompanyBranchId()),
      joiningFlag: SessionStorageService.getPartnerCompanyJoiningFlag(),
      accordionOpen: false,
      activeA284Flag: SessionStorageService.getActiveA284Flag(), //BLDE_V2-27719
    };

    this.isUseRoanOrGk =
      Number(SessionStorageService.getUseRoanFlag()) ||
      Number(SessionStorageService.getUseGkFlag());
    this.isLoginUserPrimaryCompany = isLoginUserPrimaryCompany();
    this.isLoginUserPartner = isLoginUserPartner();
    this.accordionMenuRef = React.createRef();

    // 施工体制のアコーディオン開閉イベント
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN,
      path => {
        if (this.props.path === path) {
          // 自施工体制の開閉イベントの場合は開閉状態をスイッチ
          this.switchAccordionMenu();
        } else {
          // 他施工体制の開閉イベントの場合は強制的に閉じる
          this.closeAccordionMenu();
        }
      }
    );
  }

  componentDidMount() {
    // クリック条件チェック(BLDE_V2-13193, BLDE_V2-12043)
    this.checkClickability();
  }

  componentDidUpdate(prevProps, prevState) {
    // JV切り替え後クリック条件チェック(BLDE_V2-13193, BLDE_V2-12043)
    if (this.props.nodes.permissions !== prevProps.nodes.permissions) {
      this.checkClickability();
    }
    if (this.accordionMenuRef.current) {
      //check has accordionMenu
      if (this.state.accordionOpen !== prevState.accordionOpen) {
        if (this.state.accordionOpen) {
          this.accordionMenuRef.current.addEventListener(
            TRANSITION_END_EVENT_NAME,
            this.handleTransitionEnd
          );
        } else {
          this.accordionMenuRef.current.removeEventListener(
            TRANSITION_END_EVENT_NAME,
            this.handleTransitionEnd
          );
        }
      }
    }
  }

  handleTransitionEnd = () => {
    const accordionMenu = this.accordionMenuRef.current;
    const position = accordionMenu.getBoundingClientRect().top;
    const heightWindow = window.innerHeight;
    const hiddenHeight = position + accordionMenu.offsetHeight - heightWindow;
    if (hiddenHeight > 0) {
      const extraDistance = 40; //40px
      const heightScrollDown = hiddenHeight + extraDistance;
      this.props.scrollFieldTreeMain(heightScrollDown);
    }
  };

  checkClickability() {
    let permissions = this.props.nodes.permissions;
    const { user, company } = permissions;
    let clickable =
      user.edit ||
      user.show ||
      user.register_into_field ||
      company.append_subtree ||
      company.new;
    this.setState({ clickable });
  }

  componentWillUnmount() {
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN);
  }

  /**
   * アコーディオンメニューの開閉状態を切り替える
   * */
  switchAccordionMenu = () => {
    const accordionOpen = !this.state.accordionOpen;
    this.setState({ accordionOpen });
  };

  /**
   * アコーディオンメニューを強制的に閉じる
   * */
  closeAccordionMenu = () => {
    this.setState({ accordionOpen: false });
  };

  /**
   * アコーディオンメニュー
   *
   * @returns アコーディオンメニューレイアウト
   * */
  accordionMenu() {
    // ログインユーザーの所属会社がJVかどうかの判定
    let compay_branch_id = _.find(this.props.data, id => {
      return id === this.state.companyBranchId;
    });
    let findFlag = false;
    findFlag = _.map(this.props.tree, fieldtrees => {
      _.find(fieldtrees, (value, key) => {
        if (
          key === 'prime_contractors_company_branch_id' &&
          compay_branch_id === value
        ) {
          return true;
        }
      });
    });
    if (findFlag) {
      // BOXが5次請けかの判別、「-」の左右の数字なので+1になる
      return this.accordionMenuLayout();
    }
  }

  /**
   * アコーディオンメニューレイアウト
   * @returns JSX
   */
  accordionMenuLayout() {
    const isFinishedNode = isApiFlagOn(this.props.nodes.finish_flag);
    let permissionToggleFinish = _.get(
      this.props.nodes,
      'permissions.partner_box_detail.toggle_finish'
    );

    if (permissionToggleFinish && this.isLoginUserPartner) {
      if (
        this.props.nodes.nest_no === PRIMARY_PARTNER_NODE_LEVEL ||
        !this.props.parentPermissionToggleFinish
      ) {
        //Partner can not toggle finish work by itself
        permissionToggleFinish = false;
      }
    }

    /**
     * 作業終了ボタンを表示するかを判定する
     * ログインユーザーが元請ユーザーもしくは上位の協力会社BOXの協力会社管理者、かつ作業終了フラグが0の場合のみ作業終了ボタンを表示する
     * @return {boolean} true:表示 false:非表示
     */
    const isShowDoneButton = () => {
      return (
        !isFinishedNode &&
        (this.isLoginUserPrimaryCompany ||
          (this.isLoginUserPartner && permissionToggleFinish))
      );
    };

    /**
     * 作業終了取消ボタンを表示するかを判定する
     * ログインユーザーが元請ユーザーもしくは上位の協力会社BOXの協力会社管理者、かつ作業終了フラグが1の場合のみ作業終了の取り消しボタンを表示する
     * @return {boolean} true:表示 false:非表示
     * */
    const isShowDoneCancelButton = () => {
      return (
        isFinishedNode &&
        (this.isLoginUserPrimaryCompany ||
          (this.isLoginUserPartner && permissionToggleFinish))
      );
    };

    /**
     * 施工体制の削除ボタンを表示するか判定する
     * 協力会社の場合「削除」ボタンを表示しない BLDE_V2-11957
     * 協力会社管理者の場合、かつ協力会社が「招待中」の場合、削除ボタンを表示する BLDE_V2-21500
     * @return {boolean} true:表示 false:非表示
     * */
    const isShowDeleteButton = () => {
      return (
        this.isLoginUserPrimaryCompany ||
        (this.isLoginUserPartner &&
          parseInt(this.props.nodes.approval_flag) ===
            APPROVAL_STATUS_FIELDTREE.invited.id)
      );
    };

    /**
     * 作業終了 / 作業終了取消 / 現場から削除 いずれか1でも表示が必要かどうかを判定する
     * @return {boolean} true:表示 false:非表示
     * */
    const isShowCautionItem = () => {
      return (
        isShowDoneButton() || isShowDoneCancelButton() || isShowDeleteButton()
      );
    };

    if (this.state.clickable) {
      return (
        <div className='accordion_menu' ref={this.accordionMenuRef}>
          {/*
           * 5次未満の施工体制の場合、
           * かつ作業終了していない場合は追加セクションを表示する
           */
          this.props.nodes.nest_no < 5 && this.props.nodes.finish_flag === 0 && (
            <div className='accordion_section'>
              <div className='accordion_label'>下位に協力会社を追加</div>
              <div
                className='accordion_item'
                onClick={() => {
                  if (!enableTouch()) {
                    const options = {
                      path: this.props.path,
                      nodes: this.props.nodes,
                    };
                    EventMg.trigger(FIELD_TREE_EVENTS.NEW_SEARCH, options);
                  }
                }}
                onTouchStart={() => {
                  const options = {
                    path: this.props.path,
                    nodes: this.props.nodes,
                  };
                  EventMg.trigger(FIELD_TREE_EVENTS.NEW_SEARCH, options);
                }}
              >
                <i className='icon i-add--field--tree' />
                協力会社を追加
              </div>
            </div>
          )}
          <div className='accordion_section'>
            <div className='accordion_label'>
              協力会社<span>の編集</span>
            </div>
            {this.props.nodes.permissions.partner_box_detail.show && (
              <div
                className='accordion_item'
                onClick={() => {
                  if (!enableTouch()) {
                    EventMg.trigger(
                      FIELD_TREE_EVENTS.COMPANY_EDIT,
                      this.props.path,
                      this.props.nodes
                    );
                  }
                }}
                onTouchStart={() => {
                  EventMg.trigger(
                    FIELD_TREE_EVENTS.COMPANY_EDIT,
                    this.props.path,
                    this.props.nodes
                  );
                }}
              >
                <i className='icon icon-add--field--tree--user' />
                管理者・職長を招待
              </div>
            )}
            {this.props.nodes.permissions.user.register_into_field &&
              this.props.nodes.finish_flag !== 1 &&
              !(
                isPartnerRoleId(this.state.roleId) &&
                this.state.joiningFlag === JOINING_FLAG.contractorInherent.id
              ) && (
                <div
                  className='accordion_item'
                  onClick={() => {
                    if (!enableTouch()) {
                      EventMg.trigger(
                        FIELD_TREE_EVENTS.COMPANY_WORKER_ASSIGNATION,
                        this.props.path,
                        this.props.nodes
                      );
                    }
                  }}
                  onTouchStart={e => {
                    e.preventDefault();
                    EventMg.trigger(
                      FIELD_TREE_EVENTS.COMPANY_WORKER_ASSIGNATION,
                      this.props.path,
                      this.props.nodes
                    );
                  }}
                >
                  <i className='icon icon-add--field--tree--user' />
                  作業員を追加
                </div>
              )}
            {isShowCautionItem() && (
              <div className='accordion_caution_items'>
                {isShowDoneButton() && (
                  <div
                    className='caution_item'
                    onClick={() => {
                      if (!enableTouch()) {
                        EventMg.trigger(
                          FIELD_TREE_EVENTS.COMPANY_DONE,
                          this.props.nodes
                        );
                      }
                    }}
                    onTouchStart={e => {
                      e.preventDefault();
                      EventMg.trigger(
                        FIELD_TREE_EVENTS.COMPANY_DONE,
                        this.props.nodes
                      );
                    }}
                  >
                    <i className='icon i-done--field--tree' />
                    作業終了
                  </div>
                )}
                {isShowDoneCancelButton() && (
                  <div
                    className='caution_item'
                    onClick={() => {
                      if (!enableTouch()) {
                        EventMg.trigger(
                          FIELD_TREE_EVENTS.COMPANY_DONE_CANCEL,
                          this.props.nodes.id,
                          this.props.parentFinishFlag,
                          _.isEmpty(this.props.nodes.children)
                        );
                      }
                    }}
                    onTouchStart={e => {
                      e.preventDefault();
                      EventMg.trigger(
                        FIELD_TREE_EVENTS.COMPANY_DONE_CANCEL,
                        this.props.nodes.id,
                        this.props.parentFinishFlag,
                        _.isEmpty(this.props.nodes.children)
                      );
                    }}
                  >
                    <i className='icon i-done--field--tree' />
                    作業終了取消
                  </div>
                )}
                {isShowDeleteButton() && (
                  <div
                    className='caution_item'
                    onClick={() => {
                      if (!enableTouch()) {
                        EventMg.trigger(
                          FIELD_TREE_EVENTS.COMPANY_DELETE,
                          this.props.nodes
                        );
                      }
                    }}
                    onTouchStart={e => {
                      e.preventDefault();
                      EventMg.trigger(
                        FIELD_TREE_EVENTS.COMPANY_DELETE,
                        this.props.nodes
                      );
                    }}
                  >
                    <i className='icon i-delete--field--tree' />
                    現場から削除
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  renderToolTip = () => {
    const getErrorMessage = () => {
      switch (this.props.nodes.ccus_synced_status) {
        case FIELD_TREE_CCUS_SYNCED_STATUS.FAILED.ID:
          return (
              replaceTagInErrorMessage(
                  this.props.nodes.ccus_synced_error_message
              ) || 'エラーメッセージがありません。'
          );
        case FIELD_TREE_CCUS_SYNCED_STATUS.UNSET.ID:
          return '会社情報のCCUS連携タブでCCUS事業者IDを設定してください。事業者IDが不明な場合は代表者名を設定することで仮連携することが可能です。';
        case FIELD_TREE_CCUS_SYNCED_STATUS.TEMP_DONE.ID:
          return '仮連携中は作業員情報を連携することができません。CCUS事業者IDを設定することで作業員情報も連携可能です。';
        case FIELD_TREE_CCUS_SYNCED_STATUS.NONE.ID:
          return '自動連携がONの場合は毎日夜間（CCUSメンテナンス日除く）に自動送信されます。自動連携がOFFの場合は元請による手動送信が必要です。';
        case FIELD_TREE_CCUS_SYNCED_STATUS.SECEDED.ID:
          return messageUtility.getMessage('I-000-241');
        default:
          break;
      }
    };

    if (getErrorMessage()) {
      return (
        <Tippy
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[100, 100]}
          placement='top'
          followCursor={false}
          interactive={true}
          html={
            <div className='fieldstree-company-ccus-tooltip'>
              {getErrorMessage()}
            </div>
          }
        >
          <i className='i-question--tooltip' />
        </Tippy>
      );
    }
  };

  renderCcusStatusBlock = () => {
    if (
      this.props.isCcusDisplayStateFlg &&
      !this.props.companySecededCcusFlag
    ) {
      const ccusStatus = Object.values(FIELD_TREE_CCUS_SYNCED_STATUS).find(
        element => {
          return element.ID === this.props.nodes.ccus_synced_status;
        }
      );

      const ccusStatusClassParameter = (status, parameter) => {
        if (status) {
          return status[parameter];
        } else {
          return '';
        }
      };

      const getClassName = `fieldtree-company__ccus-status ${ccusStatusClassParameter(
        ccusStatus,
        'TYPE'
      )}`;

      return (
        <div className={getClassName}>
          <span className='status-text'>
            {ccusStatusClassParameter(ccusStatus, 'NAME')}
            {this.renderToolTip()}
          </span>
        </div>
      );
    }
  };

  renderIconCautionAddUser = showCautionAddUser => {
    const cautionMessages = [];
    if (showCautionAddUser.partnerUsers) {
      cautionMessages.push(
        '管理者が現場に招待されていません。招待は各サービスを利用する場合必須ですが、上位の会社が代行する場合には任意です。'
      );
    }
    if (showCautionAddUser.foremanUsers) {
      cautionMessages.push(
        '職長が現場に招待されていません。調整会議のサービスをご利用いただく場合には招待を行ってください。'
      );
    }
    if (showCautionAddUser.operatorUsers) {
      cautionMessages.push(
        '作業員が現場に追加されていません。入退場管理や労務安全のサービスをご利用いただく場合には追加を行ってください。'
      );
    }
    if (cautionMessages.length) {
      return (
        <span className='fieldstree-company__caution'>
          <Tippy
            duration={10}
            distance={24}
            arrow='true'
            arrowType='sharp'
            placement='bottom'
            followCursor={true}
            html={cautionMessages.map((message, index) => (
              <div key={index} className='fieldstree-company__caution--tooltip'>
                {message}
              </div>
            ))}
          >
            <QuestionIcon className='icon--2x question-icon' />
          </Tippy>
        </span>
      );
    }
  };

  renderCheckbox = (node, loginUserContractor, selectedNodes) => {
    const { approval_flag, id } = node;
    if (approval_flag === APPROVAL_STATUS_FIELDTREE.approval.id) {
      return;
    }
    const key = getKeyApprovalFlagById(approval_flag);
    const hasRequestApproval = _.get(
      node,
      'permissions.partner_box_detail.request_approval'
    );
    if (loginUserContractor || hasRequestApproval) {
      return (
        <InputCheckbox
          onChange={() => this.handleOnChange(id, key)}
          node={node}
          checked={_.includes(selectedNodes[key], id)}
        />
      );
    }
  };

  handleOnChange = (id, statusText) => {
    EventMg.trigger(FIELD_TREE_EVENTS.SELECT_NODE, id, statusText);
  };

  render() {
    //this.props.nodes.approval_flag 0:承認依頼前, 1:承認済, 2:元請承認待

    const companyStatus = classname => {
      //ここで状態を変える
      const status = () => {
        const _status = APPROVAL_STATUS_FIELDTREE;
        if (this.props.nodes.finish_flag == 1) {
          return 'done';
        }
        if (this.props.nodes.approval_flag == _status.invited.id) {
          return 'notapproved';
        }
        if (this.props.nodes.approval_flag == _status.approval.id) {
          return '';
        }
        if (this.props.nodes.approval_flag == _status.pending.id) {
          return 'pending';
        }
      };
      return `${classname} ${status()} ${
        this.state.clickable ? 'fieldstree-company--operatable' : ''
      } ${this.state.accordionOpen ? 'open' : ''} ${
        this.props.isCcusDisplayStateFlg ? 'ccus-active' : ''
      }`;
    };

    /**
     * 施工体制のステータスを取得する
     * @return {string}
     * */
    const companyStatusString = () => {
      const _status = APPROVAL_STATUS_FIELDTREE;
      if (this.props.nodes.finish_flag === 1) {
        return '作業終了';
      }

      if (this.props.nodes.approval_flag === _status.invited.id) {
        return _status.invited.name;
      }

      if (this.props.nodes.approval_flag === _status.approval.id) {
        return _status.approval.name;
      }

      if (this.props.nodes.approval_flag === _status.pending.id) {
        return _status.pending.name;
      }
    };

    const styles = {
      company: {
        width: 256,
        minWidth: 256,
        maxWidth: 256,
        minHeight: 66,
        overflow: 'visible',
      },
      header: {
        width: '100%',
      },
      name: {
        fontSize: 14,
        lineHeight: 1.5,
      },
    };

    let showCautionAddUser = {};
    if (!isApiFlagOn(this.props.nodes.finish_flag)) {
      showCautionAddUser = {
        partnerUsers: _.toNumber(this.props.nodes.partner_users_count) === 0,
        foremanUsers: _.toNumber(this.props.nodes.foreman_users_count) === 0,
        operatorUsers:
          this.isUseRoanOrGk &&
          _.toNumber(this.props.nodes.operator_users_count) === 0,
      };
    }

    return (
      <div
        className={companyStatus('fieldstree-company')}
        id={`path-${this.props.path}`}
        style={styles.company}
      >
        {this.renderCcusStatusBlock()}
        <div
          className='fieldstree-company__content'
          onClick={() => {
            if (!enableTouch()) {
              EventMg.trigger(
                FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN,
                this.props.path
              );
            }
          }}
          onTouchStart={() => {
            EventMg.trigger(
              FIELD_TREE_EVENTS.TREE_ACCORDION_MENU_OPEN,
              this.props.path
            );
          }}
        >
          <div
            className={`fieldstree-company__type fieldstree-company__type--${
              this.props.nodes.joining_flag === 1 ? 'common' : 'inherent'
            }`}
          >
            <span>
              {isApiFlagOn(this.props.nodes.joining_flag)
                ? '共通'
                : isApiFlagOff(this.props.nodes.joining_flag)
                ? '固有'
                : ''}
            </span>
          </div>
          <div className='fieldstree-company__description'>
            <div className='fieldstree-company__header' style={styles.header}>
              <div className='fieldstree-company__name' style={styles.name}>
                {this.props.nodes.private_partner_company_flag ? '(別途)' : ''}
                {this.props.nodes.company_name}{' '}
                {this.props.nodes.company_branch_name}
              </div>
            </div>
            <div className='fieldstree-company__info'>
              <span>{this.props.nodes.job_names}</span>
            </div>
            <div className='fieldstree-company__members-list'>
              <span
                className={`fieldstree-company__members-item ${
                  showCautionAddUser.partnerUsers
                    ? 'fieldstree-company__members-item--caution'
                    : ''
                }`}
              >
                管理者：{this.props.nodes.partner_users_count}
              </span>
              <span
                className={`fieldstree-company__members-item ${
                  showCautionAddUser.foremanUsers
                    ? 'fieldstree-company__members-item--caution'
                    : ''
                }`}
              >
                職長：{this.props.nodes.foreman_users_count}
              </span>
              <span
                className={`fieldstree-company__members-item ${
                  showCautionAddUser.operatorUsers
                    ? 'fieldstree-company__members-item--caution'
                    : ''
                }`}
              >
                作業員：{this.props.nodes.operator_users_count}
              </span>
              {this.renderIconCautionAddUser(showCautionAddUser)}
            </div>
            {this.state.clickable && (
              <div className='field_tree-edit'>
                編集メニューを開く
                <span className='arrow' />
              </div>
            )}
          </div>
        </div>
        {this.accordionMenu()}
        {(this.props.nodes.approval_flag !==
          APPROVAL_STATUS_FIELDTREE.approval.id ||
          isApiFlagOn(this.props.nodes.finish_flag)) && (
          <div className='fieldstree-company__status'>
            <div className='fieldstree-company__status-text'>
              {companyStatusString()}
            </div>
            {isApiFlagOff(this.props.nodes.finish_flag) &&
              this.renderCheckbox(
                this.props.nodes,
                this.props.login_user_contractor,
                this.props.selectedNodes
              )}
          </div>
        )}
      </div>
    );
  }
}

const InputCheckbox = ({ node, checked, onChange }) => {
  return (
    <label className='checkbox'>
      <input
        type='checkbox'
        onChange={() => onChange(node.id)}
        checked={checked}
      />
      <i className='i-square-checkbox i-2x' aria-hidden='true' />
    </label>
  );
};



// WEBPACK FOOTER //
// ./src/components/FieldTreeCompany.jsx